import React from 'react'

import MainLayout from 'components/Layout/Main'
import OneTapScript from 'components/OneTapScript'
import { CompareProvider } from 'context/CompareContext'
import { useUser } from 'hooks'
import useViewport from 'hooks/useViewport'

import CompareDesktopLayout from './components/CompareDesktopLayout'
import CompareMobileLayout from './components/CompareMobileLayout'

/** @type {import("./types").default} */
const Compare = ({ compareData }) => {
  const { up } = useViewport()
  const [user] = useUser()
  return (
    <CompareProvider data={compareData}>
      <OneTapScript user={user} />
      {up('md') ? <CompareDesktopLayout /> : <CompareMobileLayout />}
    </CompareProvider>
  )
}

Compare.Layout = MainLayout

export default Compare
